import { render, staticRenderFns } from "./orderRecord.vue?vue&type=template&id=ace1afe0&scoped=true&"
import script from "./orderRecord.vue?vue&type=script&lang=js&"
export * from "./orderRecord.vue?vue&type=script&lang=js&"
import style0 from "./orderRecord.vue?vue&type=style&index=0&id=ace1afe0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace1afe0",
  null
  
)

export default component.exports